export const ACCEPT_FEES_REQUEST = 'ACCEPT_FEES_REQUEST'
export const ACCEPT_FEES_SUCCESS = 'ACCEPT_FEES_SUCCESS'
export const ACCEPT_FEES_FALIURE = 'ACCEPT_FEES_FALIURE'
